import { Star } from "phosphor-react";
import React from "react";

const CardShimmer = () => {
  return (
    <>
      <div className="relative overflow-hidden p-4 rounded-[40px] h-[450px] bg-slate-100">
        <div className="rounded-[30px] animate-pulse object-cover h-full w-full bg-slate-50"></div>

        <div className="flex space-x-3 items-center absolute top-9 right-9 bg-white/50 backdrop-blur-md py-4 px-6 rounded-3xl">
          <div className="animate-pulse h-3 w-14 bg-slate-200 rounded-sm font-semibold"></div>
          <Star className="text-yellow-500" size={24} weight="fill" />
        </div>
        <div className="absolute p-10 bottom-0 left-0 bg-white/50 backdrop-blur-lg w-full z-20">
          <div className=" animate-pulse h-6 w-64 rounded-md bg-slate-200 mb-4"></div>
          <div className="flex space-x-4 items-center">
            <div className="flex  animate-pulse h-4 w-24 bg-slate-200 py-1 px-2 rounded-md text-slate-900 font-medium"></div>
            <div className="animate-pulse h-[6px] w-[6px] rounded-md bg-slate-200"></div>
            <div className=" animate-pulse h-4 w-24 rounded-md bg-slate-200"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CardShimmer;
